import { useState } from "@";

// Hook for managing loading state
export const useLoading = () => {
  const [isLoading, setIsLoading] = useState(true);

  const loading = (value) => {
    setIsLoading(value);
  };

  return {
    isLoading,
    loading,
  };
};
